import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRoamresearchComponent } from './simple-icons-roamresearch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRoamresearchComponent ],
    exports:      [ SimpleIconsRoamresearchComponent ],
    bootstrap:    []
})
export class SimpleIconsRoamresearchModule {}
